import { TableNoResults } from '@ui/v2/Table/Table'

import { Box } from '@shared/components/Box'

import type { WalletsExperienceProps } from '../wallets.types'
import { CurrentWalletSection } from './CurrentWalletSection'
import { RecentActivitySection } from './RecentActivitySection'
import { WalletListSection } from './WalletListSection'

import styles from './WalletsExperience.module.scss'

export const WalletsExperience: React.FC<WalletsExperienceProps> = ({
  currentWallet,
  walletList,
  recentActivity,
  emptyState,
}) => (
  <Box className={styles.experience}>
    <Box className={styles.currentWallet}>
      {currentWallet ? (
        <CurrentWalletSection wallet={currentWallet} />
      ) : (
        <TableNoResults title={emptyState.title} content={emptyState.description} />
      )}
    </Box>
    <Box className={styles.walletList}>
      <WalletListSection walletList={walletList} />
    </Box>
    {recentActivity && (
      <Box className={styles.recentActivity} borderTop='outline-low-em' pt='x32'>
        <RecentActivitySection recentActivity={recentActivity} />
      </Box>
    )}
  </Box>
)
